'use client';

import { c as _c } from "react/compiler-runtime";
import { formatAiValue } from '@shared/utils/helpers/formatCurrency';
import { formatNumbers } from '@shared/utils/helpers/formatNumbers';
import useRole from '@shared/utils/hooks/useRole';
import useUser from '@shared/utils/hooks/useUser';
import { Zap } from 'lucide-react';
import { client } from '../../utils/trpc';
const Balance = t0 => {
  const $ = _c(23);
  const {
    isPremium,
    marginPercent
  } = t0;
  const {
    currentUser
  } = useUser();
  const {
    premiumExpires: premiumExpiresRaw
  } = useRole(client);
  let t1;
  if ($[0] !== currentUser.tronsBalance || $[1] !== isPremium || $[2] !== marginPercent || $[3] !== premiumExpiresRaw) {
    const premiumExpires = premiumExpiresRaw ? new Date(premiumExpiresRaw) : null;
    const premiumActive = premiumExpires && premiumExpires > new Date();
    const t2 = Number(currentUser.tronsBalance);
    let t3;
    if ($[5] !== isPremium || $[6] !== marginPercent || $[7] !== t2) {
      t3 = formatAiValue(t2, isPremium, marginPercent);
      $[5] = isPremium;
      $[6] = marginPercent;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    const aiValue = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="ease-[var(--ease-spring-bouncy)] relative transition-transform duration-300 hover:rotate-[10deg] hover:scale-[1.1]"><Zap size={40} className="fill-primary text-primary" aria-label="Trons" /></div>;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== currentUser.tronsBalance) {
      t5 = formatNumbers(currentUser.tronsBalance);
      $[10] = currentUser.tronsBalance;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t5) {
      t6 = <span className="text-3xl font-bold text-textPrimary">{t5}</span>;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <span className="text-sm text-textSecondary">trons</span>;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t6) {
      t8 = <div className="flex items-center gap-3">{t4}<div className="flex items-baseline gap-2">{t6}{t7}</div></div>;
      $[15] = t6;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== aiValue) {
      t9 = <span className="font-emphasis text-textPrimary">{aiValue}</span>;
      $[17] = aiValue;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    const t10 = !isPremium && ` — ${aiValue} at cost, plus our ${marginPercent}% margin`;
    let t11;
    if ($[19] !== t10 || $[20] !== t9) {
      t11 = <p className="text-sm text-textSecondary">Buys about{" "}{t9} of AI{t10}</p>;
      $[19] = t10;
      $[20] = t9;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <p className="text-sm text-textSecondary">Trons power AI features and let you send awards to other users. Purchase tron packages below or earn them through community contributions.</p>;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    t1 = <div className="anim-enter flex flex-col gap-3 rounded-xl border border-solid border-ds-border-standard bg-background-secondary p-4 [--enter-duration:400ms] [--enter-y:20px] md:p-6">{t8}{t11}{t12}{premiumActive && <p className="text-sm font-emphasis text-primary">Premium until {premiumExpires.toLocaleDateString()} — you spend trons at our exact AI cost, with no margin</p>}{premiumExpires && !premiumActive && <p className="text-sm font-emphasis text-destructive">Premium expired on {premiumExpires.toLocaleDateString()}</p>}</div>;
    $[0] = currentUser.tronsBalance;
    $[1] = isPremium;
    $[2] = marginPercent;
    $[3] = premiumExpiresRaw;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default Balance;